import { shiyong_url } from "@/components/const";

export const Saas = () => {
  return (
    <div className="flex justify-center bg-gradient-to-br from-[#ECF5FF] via-[#B9F2FA] to-[#6EC9FF]">
      <div className=" w-[1920px] pb-[130px] pt-[9.69em] flex gap-[120px] px-[15rem] relative">
        <div className="flex w-full h-full">
          <div className="flex-1 ">
            <div className="w-[610px] mt-[35px] justify-start text-zinc-800 text-5xl font-bold font-['Alibaba_PuHuiTi_3.0'] leading-[60px]">
              全球办公网络SaaS应用加速
            </div>
            <div className="flex gap-[73px] mt-[40px]">
              <div className="flex items-center gap-[20px]">
                <img
                  src="/imgs/saas/home-1.png"
                  className="w-[30px] h-[30px]"
                />
                <div className="text-[#333] text-[24px] font-regular font-['Alibaba_PuHuiTi_3.0'] leading-7">
                  企业全球办公网络加速
                </div>
              </div>
              <div className="flex items-center gap-[20px]">
                <img
                  src="/imgs/saas/home-2.png"
                  className="w-[30px] h-[30px]"
                />
                <div className="text-[#333] text-[24px] font-regular font-['Alibaba_PuHuiTi_3.0'] leading-7">
                  全球客户建联
                </div>
              </div>
            </div>

            <div className="flex gap-[73px] mt-[20px]">
              <div className="flex items-center gap-[20px]">
                <img
                  src="/imgs/saas/home-3.png"
                  className="w-[30px] h-[30px]"
                />
                <div className="text-[#333] text-[24px] font-regular font-['Alibaba_PuHuiTi_3.0'] leading-7">
                  海外推广营销品牌建设
                </div>
              </div>
              <div className="flex items-center gap-[20px]">
                <img
                  src="/imgs/saas/home-4.png"
                  className="w-[30px] h-[30px]"
                />
                <div className="text-[#333] text-[24px] font-regular font-['Alibaba_PuHuiTi_3.0'] leading-7">
                  AIGC服务加速
                </div>
              </div>
            </div>

            <div className="flex gap-[73px] mt-[20px]">
              <div className="flex items-center gap-[20px]">
                <img
                  src="/imgs/saas/home-5.png"
                  className="w-[30px] h-[30px]"
                />
                <div className="text-[#333] text-[24px] font-regular font-['Alibaba_PuHuiTi_3.0'] leading-7">
                  全球电商平台加速
                </div>
              </div>
            </div>

            <div className="mt-[40px] px-12 py-4 bg-gradient-to-r from-[#64B7FF] via-[#89ABFF] to-[#B99BFF] shadow-[0_7px_14px_0_rgba(0,0,0,0.10)]  rounded-[10px] shadow-[0px_7px_14px_0px_rgba(0,0,0,0.10)] inline-flex justify-center items-center gap-2.5">
              <a href={shiyong_url} target="_blank">
                <div className="justify-start text-white text-2xl font-bold font-['Alibaba_PuHuiTi_3.0']">
                  立即咨询
                </div>
              </a>
            </div>
          </div>

          <img src="/imgs/saas/home.png" className="w-[700px] h-[460px]" />
        </div>
      </div>
    </div>
  );
};
